import moment from 'moment';
interface DataLinkInfoDTO {
    agentInitalizedConnection: string;
    agentInitalizedAccountingLinkConfig: string;
    agentInitalizedTransactions: string;
    agentLastCompletedRefresh: string;
    agentLastCompletedBatchUpdate: string;
}

const DataLinkInfoDTO = {
    create: (initValues?: Partial<DataLinkInfoDTO>): DataLinkInfoDTO => {
        const formatDateString = (obj: Partial<DataLinkInfoDTO>, key: keyof DataLinkInfoDTO) => {
            if (obj[key]) {
                const m = moment(obj[key]);
                if (m.year() > 1900) {
                    obj[key] = m.format('L hh:mm A');
                }
                else {
                    obj[key] = '';
                }
            }
        };
        let copy: Partial<DataLinkInfoDTO> = {};
        if (initValues) {
            try {
                copy = JSON.parse(JSON.stringify(initValues));
                formatDateString(copy, 'agentInitalizedAccountingLinkConfig');
                formatDateString(copy, 'agentInitalizedConnection');
                formatDateString(copy, 'agentInitalizedTransactions');
                formatDateString(copy, 'agentLastCompletedBatchUpdate');
                formatDateString(copy, 'agentLastCompletedRefresh');
            }
            catch { console.log('error copying datalinkinfo'); }
        }        
        const defaults: DataLinkInfoDTO = {
            agentInitalizedConnection: '',
            agentInitalizedAccountingLinkConfig: '',
            agentInitalizedTransactions: '',
            agentLastCompletedRefresh: '',
            agentLastCompletedBatchUpdate: ''
        };

        return { ...defaults, ...initValues, ...copy };
    }
};

export default DataLinkInfoDTO;